/**
 * Created by harris on 17-3-5.
 */
import Net from "./Net"

let User;

function getUser() {
  if (User) {
    return User;
  }

  return User = Net.UserInfo().then( ({data}) => data).catch(e => false);
}

export default getUser;

export const refresh = function () {
  User = null;
  return getUser()
}



// WEBPACK FOOTER //
// ./src/lib/CurrentUser.js